<template>
	<div class="layout-inner dashbaord learner_prog_list">

    <navbar></navbar>

		<div class="layout-container">
      <div class="layout-content">
        <div class="col-12">

					<div class="row sub_hd_bar">
						<div class="col-12 hd_txt">
							Progress in My Programs
						</div>
					</div>

          <div class="row enrolled_prog_list" v-for="data in enrolledPrograms" v-if="!userObj.suspended && enrolledPrograms.length > 0">
						<div class="col-12 mt-3" :class="!data.validity.transactionValid ? 'alert_msg_sec' : ''">
							<div class="row">
		            <div class="col-12">
		              <template v-if="data.programThumbnail">
		                <div class="float-left mr-4">
		                  <img :src="data.programThumbnail" style="height: 80px; width: 80px;">
		                </div>
		              </template>
		              <template v-else>
		                <div class="ic_container">
		                  <div class="ic icon_program"></div>
		                </div>
		              </template>
		              <div class="mt-1 prog_info">
		                <div>{{data.programTitle}}</div>
		                <div><small>{{data.childrenCount}} Competencies</small></div>
		                <div class="sec_lnk">
		                  <a href="javascript://" @click="navigateToProgramStatus(data)" class="ace_sec_txt" tabindex="0" aria-label="My Progress">{{ showMyProgramStatusTabLabel() }}</a>
		                </div>
		              </div>
		            </div>
							</div>
							<div class="row">
		            <div class="col-12 progress_container">
		              <div class="row">
		                <div class="col-6 score">
		                  <span class="label">Score</span>
		                  <span class="progress_block" style="height: 35px; width: 70px;">
		                    <span class="state" :class="statusClass(data)" style="height: 35px; width: 70px;">
		                      <span v-if="data.isScoreNotAvailable || data.hideScoreForStudent" class="progress_val ace_sec_txt" style="font-size: 15px;">N/A</span>
		                      <span v-else class="progress_val ace_sec_txt" style="font-size: 15px;">{{data.score}}%</span>
		                    </span>
		                  </span>
		                </div>
		                <div class="col-6">
                      <div class="progress-row" v-if="showCourseProgress()">
                        <div class="progress-bar-label ace_sec_txt" :aria-label="data.inprogressCourses + ' of ' + data.totalCourses + ' courses'"></div>
                        <b-progress :max="data.totalCourses">
                          <b-progress-bar :value="data.completedCourses" :title="showBarTitle(data.completedCourses, 'completed')" class="prog_bar__completed" v-b-tooltip.click>{{data.completedCourses}}</b-progress-bar>
                          <b-progress-bar :value="data.inprogressCourses" :title="showBarTitle(data.inprogressCourses, 'in-progress')" class="prog_bar__in_progress" v-b-tooltip.click>{{data.inprogressCourses}}</b-progress-bar>
                          <b-progress-bar :value="data.notStartedCourses" :title="showBarTitle(data.notStartedCourses, 'not started')" class="prog_bar__not_started" v-b-tooltip.click>{{data.notStartedCourses}}</b-progress-bar>
                        </b-progress>
                      </div>
		                  <div class="progress-row" v-else>
		                    <div
													class="progress-bar-label ace_sec_txt"
													:title="data.childrenCompleteCount + ' of ' + data.childrenCount" v-b-tooltip.click
													:aria-label="data.childrenCompleteCount + ' of ' + data.childrenCount">
													{{data.childrenCompleteCount}} of {{data.childrenCount}}
												</div>
		                    <b-progress :max="data.childrenCount">
		                      <b-progress-bar :value="data.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
		                    </b-progress>
		                  </div>
		                  <div class="sec_lnk2" v-if="(data.validity.transactionValid && data.releaseStatus)">
		                    <b-link href="javascript://" @click="continueLearning(data)" class="ace_sec_txt" tabindex="0" :aria-label="data.learningLabel">{{data.learningLabel}}</b-link>
		                  </div>
		                </div>
										<div class="col-12 alert_msg_inner" v-if="!data.validity.transactionValid">
											<div class="row">
												<div class="col-12 msg_container" v-html="data.validity.institutionPurchaseExpirationMessage"></div>
												<div class="col-12 btn_container">
													<b-btn @click="navigateToSelectedProgram(data)">Renew</b-btn>
												</div>
											</div>
										</div>
		              </div>
		            </div>
							</div>
        		</div>
          </div>
          <div class="row enrolled_prog_list" v-if="userObj.suspended">
            <div class="col-12">
              <div class="row">
                <div class="col-12 alert_msg_sec">
                  <div class="row">
                    <div class="col-12 mt-3">
                      <div class="row alert_msg_inner">
                        <div class="col-9 msg_container">
                          <span v-html="institution.userSuspensionMessage">
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
	import _ from 'lodash'
	import { mapState, mapActions } from 'vuex'
  import Navbar from '../../misc/components/./Navbar'
  import { PACKAGE } from '../../../package_constants'
	export default {
		name: 'learner-program-list',
    components: {
      Navbar
    },
		data: () => {
			return {
				enrolledPrograms: []
			}
		},
    beforeMount () {
    	this.enrolledPrograms = []
      _.forEach(_.sortBy(this.learnerEnrollmentData, 'uuid'), (data) => {
    		this.resetData(data)
    		this.populateStreamStructure(data)
    	})
    },
    methods: {
    	...mapActions([
        'loadStreamWithStructure',
        'loadCompetencyProgress',
        'loadMicroCompetencyProgress',
        'loadContinueLearningLast',
        'loadCheckTransactionValidity',
        'loadProgramGuide',
        'loadStreamWithStructure',
        'loadStreamWithStructureSummary',
        'loadStreamLeafForCourse'
      ]),
      navigateToSelectedProgram (data) {
        let routerParams = {
          cipCode: data.programCipCode,
          programGuideCode: data.programCode,
          type: data.programType,
          returnTo: 'learnerDashboard',
          showBackToResultButton: true
        }
        return this.$router.push({name: 'programGuideMenu', params: routerParams, query: {returnTo: 'learnerDashboard'}})
      },
      resetData (data) {
        data.score = 0
        data.courseId = ''
        data.releaseStatus =true
        data.releaseLogicDetail =''
    		data.performance = 0
        data.childrenCount = 0
        data.childrenCompleteCount = 0
        data.progressSummaryCount = 0
        data.totalCourses = 0
        data.completedCourses = 0
        data.inprogressCourses = 0
        data.notStartedCourses = 0
        data.courses = []
        data.competencySummaries = []
        data.isScoreNotAvailable = true
        data.learningLabel = 'Start Learning'
      },
      async populateStreamStructure (data) {
        let validityResponse = await this.loadCheckTransactionValidity(data.programCode)
        data.validity = validityResponse
        let stream = await this.loadStreamWithStructure(data.programCode)
        let structure = stream.structure
        if (structure) {
          let children = JSON.parse(structure)
          if (children.length > 0 && children.length <2) {
            let childStructure = children[0].structure
            if (childStructure) {
              let cStructure = JSON.parse(childStructure)
              data.courses = _.sortBy(cStructure, 'order')
            }
          }else{
            let structure1 = JSON.parse(structure)
            data.courses = _.sortBy(structure1, 'order')
          }
        }

        let summaries = await this.loadStreamWithStructureSummary(data.programCode)
        for (let i = 0; i < summaries.length; i++) {
            let competencySummary =  summaries[i]
            competencySummary.uuid = data.programCode + '_' + competencySummary.uuid
            data.competencySummaries.push(competencySummary)
            data.childrenCount += competencySummary.childrenCount

            data.childrenCompleteCount += competencySummary.childrenCompleteCount
            if (competencySummary.performance) {
                  data.performance += competencySummary.performance
                  data.progressSummaryCount += 1
            }
            if(competencySummary.status==1){
              data.inprogressCourses +=1
            }
            if(competencySummary.status==2){
              data.completedCourses +=1
            }

        }

        let catalogAndCourses = this.getTotalCourseCatalogs(data.courses)
        data.totalCourses = catalogAndCourses.length
        data.notStartedCourses = (data.totalCourses - (data.inprogressCourses+data.completedCourses))
/*
      	let stream = await this.loadStreamWithStructure(data.programCode)
      	let structure = stream.structure
      	if (structure) {
          let children = JSON.parse(structure)
          if (children.length > 0) {
            let childStructure = children[0].structure
            if (childStructure) {
              let children = JSON.parse(childStructure)
              let courses = _.filter(children, (child) => {
			          return (child.entityType === 'deliverycontext')
			        })
			        let sortedCourses = _.sortBy(courses, 'order')
			        for (let i = 0; i < sortedCourses.length; i++) {
			        	let course = sortedCourses[i]
			        	let courseId = course.originUuid
			        	let mcSummary = await this.loadMicroCompetencyProgress(courseId)
			        	data.childrenCount += mcSummary.childrenCount
        				data.childrenCompleteCount += mcSummary.childrenCompleteCount
        				let competencySummary = await this.loadCompetencyProgress(courseId)
        				if ((competencySummary.status === 1) || (competencySummary.status === 2)) {
        					data.performance += competencySummary.performance
        					data.progressSummaryCount += 1
        				}
                competencySummary.uuid = data.programCode + '_' + competencySummary.uuid
                data.competencySummaries.push(competencySummary)
			        }
*/
              data.score = (data.performance / data.progressSummaryCount).toFixed(2)
                let currentProgram = await this.loadProgramGuide({
                cipCode: data.programCipCode,
                programGuideCode: data.programCode,
                type: data.programType,
                loadDataFromServer: true
              })
              data.hideScoreForStudent = currentProgram.hideScoreForStudent
              if (data.score >= 0.00) {
                  data.isScoreNotAvailable = false
              } else {
                  data.isScoreNotAvailable = true
              }
                await this.populateCurrentCompetencySummary(data)
                this.enrolledPrograms.push(data)

/*              setTimeout(() => {
                if (data.score >= 0.00) {
                  data.isScoreNotAvailable = false
                } else {
                  data.isScoreNotAvailable = true
                }
                this.populateCurrentCompetencySummary(data)
                this.enrolledPrograms.push(data)
              }, 1000)
*/      },
      async populateProgram (data) {
          let currentProgram = await this.loadProgramGuide({
          cipCode: data.programCipCode,
          programGuideCode: data.programCode,
          type: data.programType,
          loadDataFromServer: true
        })
        this.hideScoreForStudent = currentProgram.hideScoreForStudent
      },
            getTotalCourseCatalogs(entities) {
        let courses = []

        entities.forEach((item, i) => {
           if (item.entityType === 'folder') {
             if (item.structure) {
               let structure = JSON.parse(item.structure)
               if (structure) {
                 let recursionEntities = _.sortBy(structure, 'order')
                 let response = []
                 response = this.getTotalCourseCatalogs(recursionEntities)
                 courses.push(...response)
               }
             }
           } else {
             courses.push(item)
           }

        })

        return courses
      },
      showCourseProgress () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCourseProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      async populateCurrentCompetencySummary (data) {
        let isNoActivity = true
        let competencySummary = undefined
        for (let i = 0; i < data.competencySummaries.length; i++) {
          let summary = data.competencySummaries[i]
          if (summary.status > 0) {
            isNoActivity = false
            break
          }
        }
        let sortedSummaries = _.orderBy(data.competencySummaries, ['status', 'lastUpdatedTime'], ['desc', 'desc'])
        let filteredSummaries = _.filter(sortedSummaries, (summary) => {
          return (summary.status !== 2)
        })
        if (filteredSummaries.length > 0) {
          let index = isNoActivity ? (filteredSummaries.length - 1) : 0
          competencySummary = filteredSummaries[index]
        } else {
          let index = isNoActivity ? (sortedSummaries.length - 1) : 0
          competencySummary = sortedSummaries[index]
        }
        let isCourseCompleted = (competencySummary.status === 2)
          data.courseId = competencySummary.courseId

        let courseLeaf =  await this.loadStreamLeafForCourse({programCode:data.programCode, originUuid:competencySummary.courseId})

        data.releaseStatus =  courseLeaf.releaseStatus
        data.releaseLogicDetail = courseLeaf.releaseLogicDetail
          data.learningLabel = (competencySummary.status === 0) ? 'Start Learning' : 'Continue Learning'
      },
			navigateToProgramStatus (selectedProgram) {
        let routerParams = {
          cipCode: selectedProgram.programCipCode,
          programGuideCode: selectedProgram.programCode,
          type: selectedProgram.programType,
          returnTo: 'learnerProgramList',
          showBackToResultButton: true
        }
        return this.$router.push({name: 'programGuideMyProgramStatus', params: routerParams, query: {returnTo: 'learnerProgramList'}})
      },
      continueLearning (selectedProgram) {
				this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_COURSE_TOPICS', {})
        this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
        let courseId = selectedProgram.courseId
        this.loadContinueLearningLast(courseId).then(options => {
          if (options && options.length > 0) {
            if (options[0].title !== 'COURSE_FINISHED') {
              return this.$router.push({name: 'courseDashboard', params: {uuid: courseId, showLastActivity: true}})
            }
          }
          return this.$router.push({name: 'courseDashboard', params: {uuid: courseId}})
        })
			},
      showMyProgramStatusTabLabel () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
          if (programDetail) {
            let flags = programDetail.flags
            for (var i = 0; i < flags.length; i++) {
              if (flags[i].title === 'showProgramProgress' && flags[i].label) {
                return flags[i].label
              }
            }
          }
        return 'My Progress'
      },      
      statusClass (data) {
        if (data.score && !data.isScoreNotAvailable && !data.hideScoreForStudent) {
          if (data.score >= 90) {
            return 'gradeA'
          } else if (data.score >= 80 && data.score < 90) {
            return 'gradeB'
          } else if (data.score >= 65 && data.score < 80) {
            return 'gradeC'
          } else if (data.score >= 40 && data.score < 65) {
            return 'gradeD'
          } else if (data.score < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      },
			showBarTitle (count, status) {
        if (count > 1) {
          return count + ' courses are ' + status
        } else {
          return count + ' course is ' + status
        }
      }
		},
		computed: {
      ...mapState({
        'learnerEnrollmentData': state => state.dashboard.learnerEnrollmentData,
        'enabledFeatures': state => state.dashboard.enabledFeatures,
        'institution': state => state.dashboard.institution,
        'userObj': state => state.login.userObj
      })
    }
	}
</script>

<style scoped>
	.header-text {
    color: #fff;
    font-weight: 500;
    font-size: larger;
    padding-top: 5px;
  }

  .progress-row {
    position: relative;
  }

  .progress-bar-label {
    position: absolute;
    margin: auto;
    top: 0;
    left: 40px;
    bottom: 0;
    height: 27px;
    font-size: 17px;
    color: #fff;
    z-index: 1;
  }

  .progress_block {
    float: right;
    margin-top: 1px;
    width: 50px;
    position: relative;
    text-align: center;
    height: 22px;
    background: #17b8ee;
    overflow: hidden;
  }

  .progress_block .state {
    float: left;
    height: 22px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .progress_block .state .progress_val {
    font-size: 12px;
    color: #fff;
    display: block;
  }

  .gradeA {
    background: #008000;
  }

  .gradeB {
    background: #929000;
  }

  .gradeC {
    background: #eec635;
  }

  .gradeD {
    background: #ff8000;
  }

  .gradeE {
    background: #a01500;
  }

  .noGrade {
    background: #7d7d7d;
  }

  .status-not-started {
    background-color: #b4b4b4;
  }

  .status-in-progress {
    background-color: #dd9623;
  }

  .status-completed {
    background-color: #0a7714;
  }

  .status-not-completed {
    background-color: #f40909;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProgramList.vue